<app-page-header>
  <div class="header-content">
    <h3 class="page-title">Manage Client</h3>
  </div>
</app-page-header>

<section class="user-section">
  <div class="container-fluid">
    <!-- Top Bar -->
    <div class="top-actions">
      <div class="search-box">
        <i class="pi pi-search search-icon"></i>
        <input
          type="text"
          [(ngModel)]="search"
          (keyup)="searchInList.next($event)"
          placeholder="Search clients..."
        />
      </div>

      <div class="action-buttons">
        <button class="btn primary" (click)="createNew()">
          <i class="pi pi-plus"></i>
          <span>Create New</span>
        </button>
      </div>
    </div>

    <!-- Client Table - Desktop View -->
    <div class="card table-card desktop-view">
      <table class="user-table">
        <thead>
          <tr>
            <th>Client Name</th>
            <th>Contact Information</th>
            <th>Source/Lead Source</th>
            <th>Status</th>
            <th>Created Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          @if (listOfClients.length === 0) {
          <tr>
            <td colspan="6" class="no-record">No Record Found.</td>
          </tr>
          } @for ( client of listOfClients | paginate : { itemsPerPage:
          RECORD_LIMIT, currentPage: page, totalItems: totalRowCount }; track
          client; let i = $index) {
          <tr>
            <td>{{ client.first_name }} {{ client.last_name }}</td>
            <td>
              <div>{{ client.email_id }}</div>
              <div style="font-size: 0.85rem; color: #666">
                {{ client.phone_no }}
              </div>
            </td>
            <td>{{ client.lead_source || "N/A" }}</td>
            <td>
              <span
                class="status"
                [ngClass]="client.acc_active ? 'active' : 'inactive'"
              >
                {{ client.acc_active ? "Active" : "Inactive" }}
              </span>
            </td>
            <td>{{ formatDate(client.created_at) }}</td>
            <td class="actions">
              <button
                class="icon-btn success has-tooltip-left"
                data-tooltip="Active or De-active Client"
                (click)="
                  changeClientStatus(
                    client,
                    client.acc_active ? 'De-Active' : 'Active'
                  )
                "
              >
                <i class="pi pi-sync"></i>
              </button>
              <button
                class="icon-btn warning has-tooltip-left"
                data-tooltip="Edit Client"
                (click)="editClient(client)"
              >
                <i class="pi pi-pencil"></i>
              </button>
              <button
                class="icon-btn danger has-tooltip-left"
                data-tooltip="Remove Client"
                (click)="deleteClient(client)"
                title="Delete Client"
              >
                <i class="pi pi-trash"></i>
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Client Cards - Mobile View -->
    <div class="mobile-view">
      @if (listOfClients.length === 0) {
      <div class="no-record-card">
        <p>No Record Found.</p>
      </div>
      } @for ( client of listOfClients | paginate : { itemsPerPage:
      RECORD_LIMIT, currentPage: page, totalItems: totalRowCount }; track
      client; let i = $index) {
      <div class="client-card">
        <div class="client-card-header">
          <div class="client-name">
            {{ client.first_name }} {{ client.last_name }}
          </div>
          <span
            class="status"
            [ngClass]="client.acc_active ? 'active' : 'inactive'"
          >
            {{ client.acc_active ? "Active" : "Inactive" }}
          </span>
        </div>
        <div class="client-card-body">
          <div class="client-info-row">
            <i class="pi pi-envelope"></i>
            <div>
              <div class="info-label">Email</div>
              <div class="info-value">{{ client.email_id }}</div>
            </div>
          </div>
          <div class="client-info-row">
            <i class="pi pi-phone"></i>
            <div>
              <div class="info-label">Phone</div>
              <div class="info-value">{{ client.phone_no }}</div>
            </div>
          </div>
          <div class="client-info-row">
            <i class="pi pi-tag"></i>
            <div>
              <div class="info-label">Source/Lead Source</div>
              <div class="info-value">{{ client.lead_source || "N/A" }}</div>
            </div>
          </div>
          <div class="client-info-row">
            <i class="pi pi-calendar"></i>
            <div>
              <div class="info-label">Created Date</div>
              <div class="info-value">{{ formatDate(client.created_at) }}</div>
            </div>
          </div>
        </div>
        <div class="client-card-actions">
          <button
            class="icon-btn success"
            (click)="
              changeClientStatus(
                client,
                client.acc_active ? 'De-Active' : 'Active'
              )
            "
            title="Active or De-active Client"
          >
            <i class="pi pi-sync"></i>
          </button>
          <button
            class="icon-btn warning"
            (click)="editClient(client)"
            title="Edit Client"
          >
            <i class="pi pi-pencil"></i>
          </button>
          <button
            class="icon-btn danger"
            (click)="deleteClient(client)"
            title="Remove Client"
          >
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </div>
      }
    </div>

    <!-- Pagination -->
    <div id="pagination" class="pagination-container">
      <div class="pagination-info">
        <span
          >Showing <strong>{{ showcount }}</strong> of
          <strong>{{ totalRowCount }}</strong></span
        >
      </div>

      <div class="pagination-controls">
        <pagination-controls
          [maxSize]="7"
          [responsive]="true"
          [autoHide]="false"
          [directionLinks]="true"
          previousLabel="&#x276E;"
          nextLabel="&#x276F;"
          (pageChange)="pageChanged($event)"
        >
        </pagination-controls>
      </div>
    </div>
  </div>
</section>
<div class="custom-modal" [ngClass]="{ 'is-active': showPopModal }">
  <div class="custom-modal-overlay" (click)="showPopModal = false"></div>

  <div class="custom-modal-container">
    <div class="custom-modal-body">
      <ng-container>
        <form [formGroup]="newClientForm" class="form-grid">
          <!-- Profile Section -->
          <div class="profile-section">
            <div class="profile-wrapper">
              @if (!updatedClientDetail.client_icon) {
              <img
                src="../../../assets/images/user-icon.png"
                alt="Client Icon"
                class="profile-image"
              />
              } @if (updatedClientDetail.client_icon) {
              <img
                [src]="
                  editedClientId == null
                    ? preProfileUrl + updatedClientDetail.client_icon
                    : profileUrl + updatedClientDetail.client_icon
                "
                alt="Profile"
                class="profile-image"
              />
              }

              <div class="profile-action">
                <label for="profile" class="file-label">
                  <i class="fa fa-camera"></i>
                  <input
                    id="profile"
                    type="file"
                    (change)="onFileChange($event)"
                    accept=".jpg, .jpeg"
                    hidden
                  />
                </label>
                @if (updatedClientDetail.client_icon) {
                <button
                  type="button"
                  class="remove-btn"
                  (click)="deleteClientProfile()"
                >
                  Remove
                </button>
                }
              </div>
            </div>
          </div>

          <!-- Client Info Fields -->
          <div class="input-row">
            <div class="input-group">
              <label>First Name <span>*</span></label>
              <input
                type="text"
                formControlName="first_name"
                placeholder="Enter first name"
              />
              <form-validation
                [control]="newClientForm.controls.first_name"
              ></form-validation>
            </div>

            <div class="input-group">
              <label>Last Name <span>*</span></label>
              <input
                type="text"
                formControlName="last_name"
                placeholder="Enter last name"
              />
              <form-validation
                [control]="newClientForm.controls.last_name"
              ></form-validation>
            </div>

            <div class="input-group">
              <label>Company Name <span>*</span></label>
              <input
                type="text"
                formControlName="company_name"
                placeholder="Enter company name"
              />
              <form-validation
                [control]="newClientForm.controls.company_name"
              ></form-validation>
            </div>
          </div>

          <div class="input-row">
            <div class="input-group">
              <label>Contact Number <span>*</span></label>
              <input
                type="text"
                formControlName="phone_no"
                placeholder="Enter contact number"
              />
              <form-validation
                [control]="newClientForm.controls.phone_no"
              ></form-validation>
            </div>

            <div class="input-group">
              <label>Email <span>*</span></label>
              <input
                type="email"
                formControlName="email_id"
                placeholder="Enter email"
                [readonly]="editedClientId != null"
              />
              <form-validation
                [control]="newClientForm.controls.email_id"
              ></form-validation>
            </div>

            <div class="input-group">
              <label>Address</label>
              <input
                type="text"
                formControlName="client_address"
                placeholder="Enter address"
              />
            </div>
          </div>

          <div class="input-row">
            <div class="input-group">
              <label>City</label>
              <input
                type="text"
                formControlName="client_city"
                placeholder="Enter city"
              />
            </div>
            <div class="input-group">
              <label>State</label>
              <input
                type="text"
                formControlName="client_state"
                placeholder="Enter state"
              />
            </div>
            <div class="input-group">
              <label>Zip</label>
              <input
                type="text"
                formControlName="client_zip"
                placeholder="Enter ZIP"
              />
              <form-validation
                [control]="newClientForm.controls.client_zip"
              ></form-validation>
            </div>
          </div>

          <div class="input-row">
            <div class="input-group">
              <label>Source / Lead Source</label>
              <select formControlName="lead_source">
                <option value="">-- Select Source --</option>
                @for (source of sourceList; track source) {
                <option [value]="source">{{ source }}</option>
                }
              </select>
            </div>
          </div>

          <div class="input-row">
            <div class="input-group">
              <label>Client Status</label>
              <select formControlName="client_status">
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          <div class="input-group full-width">
            <label>Attachments</label>
            <div class="file-upload-section">
              <input
                type="file"
                multiple
                (change)="onAttachmentChange($event)"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
              />
              @if (selectedAttachments.length > 0) {
              <div class="attachment-list">
                @for (file of selectedAttachments; track file; let i = $index) {
                <div class="attachment-item">
                  <span>{{ file.name }}</span>
                  <button
                    type="button"
                    class="remove-attachment"
                    (click)="removeAttachment(i)"
                  >
                    <i class="pi pi-times"></i>
                  </button>
                </div>
                }
              </div>
              }
            </div>
          </div>

          <div class="input-group full-width">
            <label>Notes</label>
            <textarea
              rows="2"
              formControlName="client_notes"
              placeholder="Add notes"
            ></textarea>
          </div>
        </form>
      </ng-container>
    </div>

    <footer class="custom-modal-footer">
      <button class="cancel-btn" (click)="showPopModal = false">Cancel</button>
      <button
        class="primary-btn"
        [disabled]="
          newClientForm.invalid ||
          (!newClientForm.dirty && editedClientId != null)
        "
        (click)="updateClientDetail(newClientForm.value)"
      >
        {{ editedClientId == null ? "Save" : "Update" }}
      </button>
    </footer>
  </div>
</div>

<!-- Bulk upload component can be added here when needed -->
